import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType, HttpStatusCode } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IExportDeclarationTask } from '../interfaces';
import { ExportDeclarationTaskMapper } from '../mappers';

export type IGetDeclarationsExportTasksRepoResponse =
  | IRepoResponse<HttpStatusCode.OK, IExportDeclarationTask[]>
  | IRepoResponse<HttpStatusCode.BAD_REQUEST | HttpStatusCode.INTERNAL_SERVER_ERROR, string>;

export type IGetDeclarationsExportTasksRepo = IRepo<[Record<string, any>], IGetDeclarationsExportTasksRepoResponse>;

export const GetDeclarationsExportTasksRepoType = Symbol.for('GetDeclarationsExportTasksRepo');

@bind(GetDeclarationsExportTasksRepoType)
export class GetDeclarationsExportTasksRepo implements IGetDeclarationsExportTasksRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: Record<string, any> = {}): Promise<IGetDeclarationsExportTasksRepoResponse> {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/export/declaration/task_list', query) });
      if (result.status === HttpStatusCode.OK) {
        const data: IExportDeclarationTask[] = result.data.data.map(ExportDeclarationTaskMapper.toDomain);

        return {
          status: HttpStatusCode.OK as HttpStatusCode.OK,
          response: data,
        };
      } else {
        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: HttpStatusCode.INTERNAL_SERVER_ERROR as HttpStatusCode.INTERNAL_SERVER_ERROR,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
